import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setFaroView, pushFaroEvent } from "../services/faro";

const useFaroRouteTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const viewName = location.pathname;
    setFaroView(viewName);
    pushFaroEvent(
      "route_change",
      {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
      },
      "navigation"
    );
  }, [location.pathname]);
};

export default useFaroRouteTracking;
